// extracted by mini-css-extract-plugin
export default {"wrapper":"LogOnTimer_wrapper--esp","info":"LogOnTimer_info--xul","inner":"LogOnTimer_inner--DqX","icon":"LogOnTimer_icon--UZh"};